import { render, staticRenderFns } from "./LayoutBuilder.vue?vue&type=template&id=2a0a2cdc&"
import script from "./LayoutBuilder.vue?vue&type=script&lang=js&"
export * from "./LayoutBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports